export const middleMainNav = [
  {
    url: 'http://zhongkao.xdf.cn/',
    title: '中考频道'
  },
  {
    url: 'http://gaokao.xdf.cn/',
    title: '高考频道'
  },
  // {
  //   url: `http://souke.xdf.cn/Teacher/0.html`,
  //   title: '名师天地'
  // },
  // {
  //   url: 'http://gaokao.xdf.cn/list_8705_1.html',
  //   title: '明星学员'
  // }
]



// WEBPACK FOOTER //
// ./src/api/js/middleschool/mainnav.js